
import ApiService from 'services/ApiService/ApiService';
import {
  CHECK_MODAL,
  CHECK_MODAL_TYPE,
  CONSENT_URL,
  CONSENT_URL_LIST,
} from 'pages/Settings/AccountSettings/Privacy/Api';
import { USER_MODALS_GROUP } from 'enum/helpers';


export const getUpdatedConsentData = async(username) => {
  const url = ApiService.substitute(CHECK_MODAL_TYPE, {
    username: encodeURIComponent(username),
    modalType: encodeURIComponent(USER_MODALS_GROUP.COOKIES_POLICY_UPDATED),
  });

  let data = undefined;
  let error = undefined;

  try {
    const response = await ApiService.get(url);

    data = response?.data;
  } catch (err) {
    error = err;
  }

  return { data, error };
};

export const getConsentData = async(username) => {
  const url = ApiService.substitute(
    CONSENT_URL_LIST,
    { username: encodeURIComponent(username) }
  );

  let data = undefined;
  let error = undefined;

  try {
    const response = await ApiService.get(url);

    data = response?.data;
  } catch (err) {
    error = err;
  }

  return { data, error };
};

export const postAcceptCookies = (username) => {
  const url = ApiService.substitute(
    CONSENT_URL,
    { username: encodeURIComponent(username) }
  );

  const data = [{
    consentType: 'COOKIES',
    userConsentStatus: 'APPROVED',
  }];

  ApiService.post(url, { data });
};

export const postAcceptUpdatedCookies = (username) => {
  const url = ApiService.substitute(
    CHECK_MODAL,
    { username: encodeURIComponent(username) }
  );

  const data = {
    modalType: USER_MODALS_GROUP.COOKIES_POLICY_UPDATED,
    action: 'OK',
  };

  ApiService.post(url, { data });
};
